// Module
var code = "<script id=\"wcc-components-vote-bubble\" type=\"text/template\">\r\n    <!-- ko if: hasTitle -->\r\n    <span data-bind=\"text: title\"></span>\r\n    <!-- /ko -->\r\n\r\n    <!-- ko if: hasIcon -->\r\n    <span data-bind=\"css: icon\"></span>\r\n    <!-- /ko -->\r\n</script>";
// Exports
module.exports = code;